<template>
    <div class="greybox mt-3">
        <h1>Required Supporting Documents</h1>
        <div v-if="isApproved" class="alert alert-success" role="alert">
            <span style="font-size: 48px; color: green;">
              <i class="fas fa-check"></i>
            </span>
            <p>Your claim has been approved so we do not require you to upload any supporting documents.</p>
        </div>
        <div v-else>
          <p>To proceed with your claim, we require you to provide the documents or information requested.</p>
          <p>Once all required supporting documents have been received, we will complete a full assessment of the claim.</p>
          <p>If you are unable to supply a document requested, please send us an email to tell us why you are unable to supply the document.</p>
          <p class="lead mt-5"><i class="fas fa-info-circle"></i> Remember to click Upload when you have selected a file(s)</p>
          <div class="supporting-doc-card-body">
              <div v-for="(type, index) in documentTypes" :key="index" class="supporting-doc-card-body-upload-section mt-3">
                  <h3>{{type.label}}</h3>
                  <p v-if="type.tip" class=""><i class="fas fa-info-circle"></i> {{type.tip}}</p>
                  <document-upload
                      v-model="documents"
                      :fileType="type.id"
                      :entityRef="claimId"
                      :entityType="entityType"
                      @status="() => {}"
                      :ref="type.id">
                  </document-upload>
              </div>
          </div>
          <button class="button mt-2" @click="handleCloseClick()">Close</button>
          
          <confirmDialog v-if="confirmDialog" @close="confirmDialog = false" :showFooter="true">
            <template v-slot:header>
              <h4 class="mb-0">Unsaved Data Warning</h4>
            </template>
            <template v-slot:body>
              <div class="px-5 py-4">
                <p>Some documents have not been uploaded yet.</p>
                <p>What would you like to do?</p>            
                <label class="radio-container">
                    Upload documents
                    <input
                        type="radio"
                        id="clearOrUploadDocs"
                        v-model="clearOrUpload"
                        :value="true">
                    <span class="checkmark"></span>
                </label>
                <label class="radio-container">
                    Clear documents
                    <input
                        type="radio"
                        fieldlabel="Occurred abroad"
                        id="clearOrUploadDocs"
                        v-model="clearOrUpload"
                        :value="false">
                    <span class="checkmark"></span>              
                </label>
              </div>            
            </template>
            <template v-slot:footer>
              <button class="button buttonSecondary mr-2" @click="confirmDialog = false">Go Back</button> 
              <button class="button" @click="handleNext">Next</button>                     
            </template>
          </confirmDialog>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import DocumentUpload from '@/components/Upload.vue'
import confirmDialog from '../../components/ConfirmDialog'

const DEFAULT_PATH = '/'

export default {
  name: 'supportingDocUpload',
  components: {
    DocumentUpload,
    confirmDialog
  },
  beforeRouteLeave(to, from, next) {
    if (this.checkForFiles()) {
      this.nextUrl = to.path;
      this.confirmDialog = true;
    } else {
      next()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // check for login and keep default...
      let { path } = from
      if (path != '/login') {
        vm.referer = path
      }
    })
  },
  beforeMount () {
    // let { submissionResponse } = this.$store.state.claimform
    // if (submissionResponse) {
    //     let { incidentType } = submissionResponse
    //     if (incidentType) {
    //         this.fetchDocumentTypes(incidentType.id);
    //     }
    // }
    //myclaims.selectedClaim.incidentParentTypeId --> incidentTypeId
    let { selectedClaim } = this.$store.state.myclaims;
    let incidentId = -1;  
    if(selectedClaim) {
      incidentId = selectedClaim.incidentParentTypeId == null || selectedClaim.incidentParentTypeId == 0 ? 
                      selectedClaim.incidentTypeId : selectedClaim.incidentParentTypeId;
    }
    
    this.fetchDocumentTypes(incidentId);
  },
  computed: {
    isLoading () {
      return this.$store.state.myclaims.loading
    },
    selectedClaim () {
      return this.$store.state.myclaims.selectedClaim
    },
    documentTypes () {
      return this.$store.state.claimform.documentTypes
    },
    claimIdFromParam () {
      let { params } = this.$route
      if (params) {
        return params.id
      }
      return null
    },
    claimId () {
      let { selectedClaim } = this.$store.state.myclaims
      let { params } = this.$route

      if (selectedClaim) {
        return selectedClaim.id
      }

      if (params) {
        return params.id
      }

      return null
    },
    isApproved () {
      if (this.selectedClaim && 
        this.selectedClaim.hasOwnProperty("status")) {
          if (this.selectedClaim.status === 'APPROVED') {
            return true
          }
      }
      return false;
    },
  },
  data () {
    return {
      referer: DEFAULT_PATH,
      entityType: 1000,
      documents: [],
      confirmDialog: null,
      clearOrUpload: null,
      nextUrl: null
    }
  },
  methods: {
    ...mapActions({
      fetchDocumentTypes: 'claimform/fetchDocumentTypes'
    }),
    handleCloseClick () {
      this.nextUrl = this.referer;
      this.$router.push({ path: this.referer })
    },
    checkForFiles() {      
      var app = this;
      var notUploaded = false;
      Object.keys(this.$refs).forEach(function(key) {        
        // console.log(key, app.$refs[key][0].files.length);
        if(app.$refs[key][0].files.length > 0) {
          notUploaded = true;
        } 
      })
      return notUploaded;
    },
    bulkUpload() {
      // console.log(this.$refs[1000][0])
      var app = this;
      Object.keys(this.$refs).forEach(function(key) {        
        // console.log(key, app.$refs[key][0].files.length);
        if(app.$refs[key][0].files.length > 0) {
          app.$refs[key][0].submitFiles();
        } 
      })
      this.confirmDialog = false;
    },
    bulkClearFiles() {
      var app = this;
      Object.keys(this.$refs).forEach(function(key) {        
        if(app.$refs[key][0].files.length > 0) {
          // console.log(app.$refs[key][0].files)
          app.$refs[key][0].files = [];
        } 
      })
    },
    handleNext() {
      if(this.clearOrUpload) { 
        // console.log('true upload docs and move on');
        this.bulkUpload()
        this.$router.push({path: this.nextUrl})
      } else {
        // console.log('false clear uploaded docs and move on');
        this.bulkClearFiles();
        this.confirmDialog = false;
        this.$router.push({path: this.nextUrl})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .checkmark {
    background: #eeeeee
  }
</style>